export type StartType = "cold" | "warm" | "resume";

export interface HomeStartContext {
  firstHome: boolean;
  navigationType?: string;
  launchSurface?: boolean;
  homeStartedAt: number;
  lastVisibleAt?: number;
}

/** Times share one monotonic clock. Only actual hidden-to-visible transitions count. */
export function classifyStartType(
  context: HomeStartContext
): StartType | undefined {
  const { homeStartedAt, lastVisibleAt } = context;
  if (
    Number.isFinite(homeStartedAt) &&
    lastVisibleAt !== undefined &&
    Number.isFinite(lastVisibleAt) &&
    lastVisibleAt >= 0 &&
    homeStartedAt >= lastVisibleAt &&
    homeStartedAt - lastVisibleAt <= 2000
  )
    return "resume";
  if (!context.firstHome) return undefined;
  if (context.launchSurface === true || context.navigationType === "navigate")
    return "cold";
  if (["reload", "back_forward"].includes(context.navigationType ?? ""))
    return "warm";
  // Missing navigation information cannot establish a cold launch.
  return undefined;
}
